var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaffeineSensitivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EE8F61;}\n\t.st1{fill:#97A8B3;}\n\t.st2{fill:#CBD5DC;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#925F36;}\n\t.st5{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,183.6c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.4,149.2,63.2,183.6,106,183.6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.9,123.5c0,12.6-18.4,22.8-41.1,22.8c-22.7,0-41.1-10.2-41.1-22.8s18.4-22.8,41.1-22.8 C127.5,100.7,145.9,110.9,145.9,123.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.9,119c0,12.6-18.4,22.8-41.1,22.8c-22.7,0-41.1-10.2-41.1-22.8s18.4-22.8,41.1-22.8 C127.5,96.1,145.9,106.4,145.9,119"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.8,135C70.7,135,66,100.7,66,91.6h77.6C143.6,96.1,139.2,135,104.8,135"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.2,86.2c5.6-23.1-22.3-17.6-27.9-13.2c-3.1-0.3-6.2-0.5-9.5-0.5C83.4,72.4,66,79.8,66,91.7 s17.4,21.6,38.8,21.6c21.4,0,38.8-9.7,38.8-21.6C143.6,89.7,143.1,87.9,142.2,86.2 M136.5,80.1c-3.1-2.1-7.1-3.9-11.7-5.1 C129.1,73.6,135.2,74.2,136.5,80.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M139.1,93.9c0,8.8-15.3,16-34.2,16c-18.9,0-34.2-7.2-34.2-16s15.3-16,34.2-16C123.7,77.9,139.1,85,139.1,93.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.7,92.3c-0.6,0-1.2-0.2-1.6-0.7c-5.3-5.3-5.4-11.2-0.3-18.9c1.7-2.5,2-4.8,1.1-6.7c-1-2.2-3.3-3.4-3.8-3.4 c-1.2,0-2.3-1-2.3-2.3c0,0,0,0,0,0c0-1.3,1-2.3,2.3-2.3c2.3,0,5.9,2.2,7.7,5.5c1.1,2.1,2.4,6.3-1.2,11.7c-4.5,6.7-3.5,9.9-0.3,13.1 c0.9,0.9,0.9,2.3,0,3.2C96.9,92.1,96.3,92.3,95.7,92.3 M109.4,96.9c-0.6,0-1.2-0.2-1.6-0.7c-5.3-5.3-5.4-11.2-0.3-18.9 c1.7-2.5,2.1-5.1,1.1-7.7c-1.1-2.8-3.3-4.6-4-4.7c-1.3,0-2.2-1-2.2-2.3s1.1-2.3,2.4-2.3c2.3,0,5.5,2.6,7.3,6 c2.4,4.4,2.1,9.2-0.8,13.5c-4.5,6.7-3.5,9.9-0.3,13.1c0.9,0.9,0.9,2.3,0,3.2C110.6,96.6,110,96.9,109.4,96.9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 64.2,
    className: "st5",
    width: 82.2,
    height: 82.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaffeineSensitivity);
export default __webpack_public_path__ + "static/media/Caffeine_Sensitivity.bd359d06d46f76a86abbec91efe3e403.svg";
export { ForwardRef as ReactComponent };